import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';
import type { Space } from '../../controllers/space-store/types';

export type SearchSpacesResponse = { data: Space[]; totalCount: number };

export type SearchSpacesFetchParams = {
	cloudId: string;
	product: string;
	experienceId: string;
	query: string;
	limit?: number;
};

export const searchSpacesFetchAction = async ({
	cloudId,
	product,
	experienceId,
	query,
	limit = 20,
}: SearchSpacesFetchParams): Promise<SearchSpacesResponse> => {
	const params = new URLSearchParams({ q: query, limit: String(limit) });
	return performHttpFetch({
		path: `${SPACES_API_PATH}/search?${params.toString()}`,
		options: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		},
	});
};
